var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleTable',{attrs:{"columns":_vm.columns,"data":_vm.data,"localize-headers":""},scopedSlots:_vm._u([{key:"type",fn:function(ref){
var value = ref.value;
return _c('strong',{},[_vm._v(_vm._s(value))])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }